import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FormControlName } from '@angular/forms';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[inputTrim]',
    standalone: false
})
export class InputTrimDirective implements OnInit, OnDestroy {
  destroy$ = new Subject();

  constructor(private control: FormControlName) {}

  ngOnInit() {
    this.control?.valueChanges?.pipe(takeUntil(this.destroy$), distinctUntilChanged()).subscribe(x => {
      this.control.control.setValue(x.trim());
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
